export type IdentityGenerationToken = Readonly<{
  identity: string | null;
  generation: number;
}>;

/**
 * Не позволяет отложенному действию прежнего пользователя продолжиться после
 * смены авторизации или перенастройки телефона.
 */
export class IdentityGenerationGuard {
  private identity: string | null;
  private generation = 0;

  constructor(identity: string | null) {
    this.identity = identity;
  }

  capture(): IdentityGenerationToken {
    return { identity: this.identity, generation: this.generation };
  }

  isCurrent(token: IdentityGenerationToken): boolean {
    return token.identity === this.identity && token.generation === this.generation;
  }

  switchIdentity(identity: string | null): void {
    if (identity === this.identity) return;
    this.identity = identity;
    this.invalidate();
  }

  invalidate(): void {
    this.generation += 1;
  }
}
